import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import lbx_panel_bg from '../assets/lbx_panel_bg.png';
import lbx_panel_center from '../assets/lbx_panel_center.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import './lbxai_DetailPanel.css';
import PanelNavbar from './PanelNavbar';

const LBxAIDetailPanel = ({ isOpen, onClose, sectionData }) => {
    const nextSectionRef = useRef(null);

    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const scrollToNextSection = () => {
        if (nextSectionRef.current && contentRef.current) {
            const yOffset = -100;
            const container = contentRef.current;
            const element = nextSectionRef.current;
            const containerY = element.offsetTop + yOffset;
            container.scrollTo({ top: containerY, behavior: 'smooth' });
        }
    };

    return (
        <div className={`detail-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div
                ref={contentRef}
                className={`detail-panel-content lbxai-panel ${isOpen ? 'open' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <PanelNavbar onClose={onClose} logo="" />
                <div className="panel-container">
                    <div
                        className="panel-hero-bg"
                        style={{
                            backgroundImage: `url(${lbx_panel_bg})`,
                        }}
                    ></div>
                    <div className="panel-body">
                        <h1 className="panel-main-title">Transform liquid biopsy data into predictive cancer insights</h1>
                        <p className="panel-description-text">
                            Want to understand how patients may respond to treatment — before the results arrive? LBx-AI analyzes liquid biopsy signals to uncover biomarkers, predict response patterns, and support data-driven treatment decisions.
                        </p>
                        <button className="panel-try-btn" onClick={scrollToNextSection}>
                            <span className="panel-try-btn-text">Explore LBx-AI</span>
                        </button>
                    </div>
                    <div className="panel-center-image-container">
                        <img
                            src={lbx_panel_center}
                            alt="LBx-AI Analysis"
                            className="panel-center-image"
                        />
                    </div>

                    <div className="panel-next-section" ref={nextSectionRef}>
                        <div className="section-title-group">
                            <h2 className="section-title-large">Predictive intelligence</h2>
                            <div className="accuracy-label-container">
                                <div className="accuracy-line"></div>
                                <div className="accuracy-ellipse"></div>
                                <span className="accuracy-text">powered by circulating tumor signals</span>
                            </div>
                        </div>

                        <div className="section-description-rich">
                            <p>
                                <span className="text-italic-medium">LBx-AI</span>
                                <span> is Lantern Labs’ machine learning module designed to interpret liquid biopsy data for early insights into treatment response. By analyzing circulating tumor DNA and other liquid biopsy features, LBx-AI identifies meaningful biomarkers and stratifies patient subgroups with high accuracy.</span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                                <span>The module reveals patterns linked to </span>
                                <span className="text-medium">therapy sensitivity</span>
                                <span>, </span>
                                <span className="text-medium">disease progression</span>
                                <span>, and </span>
                                <span className="text-medium">clinical outcomes</span>
                                <span> — providing clinicians and researchers with non-invasive, data-driven intelligence to guide personalized care and trial design.</span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                            </p>
                        </div>
                    </div>

                    <div className="panel-demo-section">
                        {/* Decorative Background Elements */}
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-1" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-2" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-3" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-4" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-5" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-6" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-7" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-8" />

                        <div className="demo-content-wrapper">
                            <div className="demo-text-box">
                                <h2 className="demo-title">
                                    <span className="demo-title-light">Discover how </span>
                                    <span className="demo-title-medium">LBx-AI</span>
                                    <span className="demo-title-light"> extracts signal from noise to surface clinically relevant biomarkers and treatment indicators</span>
                                    <br />
                                </h2>
                            </div>

                            <div className="demo-symbol-container">
                                <div className="demo-vertical-line"></div>
                                <div className="demo-symbol-ellipse"></div>
                                <Link
                                    to="/contact"
                                    className="demo-try-btn"
                                    style={{
                                        textDecoration: 'none',
                                        position: 'relative',
                                        left: 'unset',
                                        top: 'unset',
                                        transform: 'unset',
                                        marginTop: '50px'
                                    }}
                                >
                                    <span className="demo-try-btn-text">Contact us</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LBxAIDetailPanel;

